import { Box, Dialog, Modal } from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";

type Props = {
  open: boolean;
  handleOpen: (open: boolean) => void;
};

export const DonationModal = ({ open, handleOpen }: Props) => {
  return (
    <Dialog open={open} onClose={() => handleOpen(false)} fullWidth>
      <Box
        className="modal modal-content"
        sx={{ borderRadius: "5px !important" }}
      >
        <Box className="modal-header border-0 pb-0">
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => handleOpen(false)}
          ></button>
        </Box>
        <Box className="modal-body p-7">
          <Box className="text-center mb-5">
            <h6 className="modal-title fs-5">Donations</h6>
            <p className="text-muted">
              Support the future of innovation by donating to UPCX blockchain
              development, where your contribution helps build secure and
              transparent solutions for everyone.
            </p>
          </Box>
          <Box className="mb-5">
            <h6 className="modal-title fs-5">1. Ethereum</h6>
            <p className="text ms-5 cursor-pointer">
              0x23E8544643390a0B49576850569876065b4Eb646
            </p>
            <Box className="text-center mt-5">
              <QRCodeCanvas
                value="ethereum:0x23E8544643390a0B49576850569876065b4Eb646"
                size={200}
                bgColor="#fff"
                fgColor="#000"
                level="L"
              />
            </Box>
          </Box>
          <Box className="mb-5">
            <h6 className="modal-title fs-5">2. Bitcoin</h6>
            <p className="text ms-5 cursor-pointer">
              bc1q20k34jnswz5fe4030k4wq35rrcw8nmjr0lt7u5
            </p>
            <Box className="text-center mt-5">
              <QRCodeCanvas
                value="bitcoin:bc1q20k34jnswz5fe4030k4wq35rrcw8nmjr0lt7u5"
                size={200}
                bgColor="#fff"
                fgColor="#000"
                level="L"
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};
